import React, { useRef, useEffect, useState } from 'react'
import { useUpdateEffect } from 'react-use'

import produce from 'immer'

import TextareaAutosize from 'react-textarea-autosize'

import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import { content, content_block } from '@/store/template/content'
import {
  undoHistoryAction,
  undoHistoryActionCount,
} from '@/store/builder/history'
import { isBuilder } from '@/store/builder/store'

// components
import Title from '@/components/onepager/sections/Title'

function LongText({ id, contentID, sectionData, wrapperId }) {
  const [getContent, setContent] = useRecoilState(content(contentID))
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getHistoryAction, setHistoryAction] = useRecoilState(undoHistoryAction)
  const [getHistoryActionCount, setHistoryActionCount] = useRecoilState(
    undoHistoryActionCount
  )

  // undoSystem -- Content System
  useUpdateEffect(async () => {
    if (isBuilderApp) {
      if (!getHistoryAction) {
        setHistoryActionCount(getHistoryActionCount + 1)
      } else {
        setHistoryAction(false)
      }
    }
  }, [getContent])

  const updateContent = e => {
    const nextState = produce(getContent, draft => {
      draft.content = e.target.value
    })
    setContent(nextState)
  }

  return (
    <div>
      <Title
        id={id}
        title={sectionData.title}
        prompt={sectionData.prompt}
        wrapperId={wrapperId}
      />

      <div className="boxBody">
        <TextareaAutosize
          className="block w-full text-lg sectionLongText font-medium outline-none"
          value={getContent.content}
          placeholder={sectionData.data.placeholder}
          onChange={updateContent}
        />
      </div>
    </div>
  )
}

export default LongText
